import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import teamimg from '../assets/img/de.jpg';
import teamimg2 from '../assets/img/parabsir.png'

const lawyers = [
  {
    name: "Adv. Niranjan Jagtap",
    title: "Senior Partner",
    img:teamimg,
  },{
    name: "Adv. Shreeprasad Parab",
    title: "Senior Partner",
    img: teamimg2,
  },
  {
    name: "Adv. Harnam Singh",
    title: "Senior Partner",
    img: teamimg,
  },
  
];

const OurLawyers = () => {
    useEffect(() => {
      AOS.init({ duration: 1000 });
    }, []);
  return (
    <section className="our-lawyers py-5 text-center" data-aos="fade-up">
      <Container>
        <h2 className="section-title mb-3">Our Lawyers</h2>
        <p className="section-subtitle mb-5">
          Meet our team of dedicated legal professionals, committed to providing expert advice
          and tailored solutions to meet your legal needs.
        </p>
        <Row className="d-flex justify-content-center">
          {lawyers.map((lawyer, index) => (
            <Col md={3} sm={6} key={index} className="mb-4">

              <Card className="lawyer-card border-0 shadow-sm">
                <div className="card-img-wrapper">
                  <Card.Img variant="top" src={lawyer.img} className="lawyer-img" />
                  <div className="overlay">
                    <div className="social-icons">
                      <a href="#"><FaFacebookF /></a>
                      <a href="#"><FaTwitter /></a>
                      <a href="#"><FaLinkedinIn /></a>
                      <a href="#"><FaInstagram /></a>
                    </div>
                  </div>
                </div>
                <Card.Body>
                  <Card.Title>{lawyer.name}</Card.Title>
                  <Card.Text className="text-muted">{lawyer.title}</Card.Text>
                </Card.Body>
              </Card>

            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default OurLawyers;
